import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router';
import MainLogo from '../../public/images/GHmain.png';

const StyledImg = styled.img`
  width: ${(p) => p.width};
`;

interface LogoProps {
  width?: string;
}

const Logo = ({ width }: LogoProps) => (
  <Link to="/">
    <StyledImg width={width} src={MainLogo} alt="Grantholster" />
  </Link>
);

export default Logo;
